module.exports = __webpack_public_path__ + "static/media/hoc.954d64f9.webp";